import React from "react";
import { Stack, Typography } from "@mui/material";
import { dateFormatter } from "../../utils/masking";

interface Customer {
  registrationSource?: string;
  registrationDate?: string;
  modifiedDate?: string;
}

interface RegistrationDetailsProps {
  customer: Customer;
}

export const RegistrationDetails = ({ customer }: RegistrationDetailsProps) => {
  const renderInfoRow = (label: string, value: string | undefined, formatter?: (val: string) => string) => {
    const display = value ? (formatter?.(value) ?? value) : `No ${label}`;
    return (
      <Stack direction="row" justifyContent="space-between">
        <Typography variant="body2" fontWeight={600}>{label}:</Typography>
        <Typography variant="body2">{display}</Typography>
      </Stack>
    );
  };

  return (
    <Stack spacing={1}>
      {renderInfoRow("Source", customer.registrationSource)}
      {renderInfoRow("Date", customer.registrationDate, dateFormatter)}
      {renderInfoRow("Modified Date", customer.modifiedDate, dateFormatter)}
    </Stack>
  );
};
